import { Activity, Star } from "lucide-react";
import { AppStoreButton } from "@/components/AppStoreButton";

export const FooterSection = () => (
  <footer
    data-testid="footer-section"
    className="border-t border-white/10 px-4 pb-32 pt-24 sm:px-6 md:pb-24 lg:px-8"
  >
    <div className="mx-auto max-w-7xl text-center">
      <h2 className="mx-auto max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
        Never guess your balance again.
      </h2>
      <p className="mx-auto mt-4 max-w-xl text-base text-slate-400">
        Join Payment Pulse today on iOS and take control of your 30-day
        payment horizon.
      </p>
      <div className="mt-8 flex justify-center">
        <AppStoreButton testId="footer-appstore-button" sublabel="Free on iOS" />
      </div>
    </div>

    <div className="mx-auto mt-20 flex max-w-7xl flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 text-sm text-slate-500 sm:flex-row">
      <span className="flex items-center gap-2">
        <Activity className="h-4 w-4 text-sky-400" />
        Payment Pulse by Walter Paul Bebirian
      </span>
      <span className="flex items-center gap-1.5">
        <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
        5.0 on the App Store
      </span>
      <span>© 2026 Payment Pulse. All rights reserved.</span>
    </div>
  </footer>
);
